import React from "react"
import { Carousel } from "react-bootstrap"
import { Link } from "gatsby"
import slider1 from "../assets/images/slider-1.jpg"
import slider2 from "../assets/images/slider-2.jpg"

const Hero = () => {
  return (
    <section className="hero">
      <Carousel fade prevLabel="" nextLabel="">
        <Carousel.Item>
          <div className="hero-img-container">
            <img
              src={slider1}
              className="hero-img"
              alt="First slide"
              // placeholder="tracedSVG"
            />
          </div>
          <Carousel.Caption className="text-lg-start text-center">
            <h1 className="main-heading">
              Worried About <span className="green">Tax?</span>
            </h1>
            <h2 className="my-3">We are here to help you</h2>
            <Link to="/contact">
              <button className="btn btn-primary btn-lg hero-btn">
                Contact Us
              </button>
            </Link>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <div className="hero-img-container">
            <img
              src={slider2}
              className="hero-img"
              alt="Third slide"
              // placeholder="tracedSVG"
            />
          </div>
          <Carousel.Caption className="text-lg-start text-center">
            <h1 className="main-heading">
              Worried About <span className="green">Tax?</span>
            </h1>
            <h2 className="my-3">We are here to help you</h2>
            <Link to="/contact">
              <button className="btn btn-primary btn-lg hero-btn">
                Contact Us
              </button>
            </Link>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </section>
  )
}

export default Hero
